import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchVehicleQuery = (parameters = {}) => {
  return apiActionCreator({
    'endpoint': `/bulletin/vehicle${getUrlParameters(parameters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLE_QUERY,
      ActionTypes.FETCHED_VEHICLE_QUERY,
      [
        ActionTypes.FETCHED_VEHICLE_QUERY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'GET',
  });
};

export const clearVehicleQuery = () => ({
  'type': ActionTypes.CLEAR_VEHICLE_QUERY,
});
